import {Component, OnInit} from '@angular/core';
import {UserService} from '../shared/user.service';
import {DriverService} from '../shared/driver.service';
import {NavigationService} from '../../shared/services/navigation.service';
import {UserSearchCriteria} from '../../shared/user-search-criteria';

@Component({
  selector: 'app-administrator-list',
  templateUrl: './administrator-list.component.html',
  styleUrls: ['./administrator-list.component.scss']
})
export class AdministratorListComponent implements OnInit {

  filters = new UserSearchCriteria();

  loadPage = (page: number, pageSize: number) => this.userService.searchAdministrators(page, pageSize, this.filters);

  constructor(
    private userService: UserService,
    private driverService: DriverService,
    private navigation: NavigationService,
  ) {
  }

  ngOnInit() {
  }

  goToCreateAdministrator(): void {
    this.navigation.administrators()
      .create()
      .go();
  }

  goToEditAdministrator(id: string): void {
    this.navigation.administrators()
      .edit(id)
      .go();
  }

}
